import React from 'react'
import ReactInlineSVG from 'react-inlinesvg'

const Svg = ({ src, clickHandler, className }) => (
    <ReactInlineSVG
        {...{
            src,
            onClick: (e) =>
                typeof clickHandler === 'function' && clickHandler({ e }),
            className,
        }}
    />
)

export default Svg
